//intro
var introAnimation = bodymovin.loadAnimation({
    container: document.getElementById('bodyMovin'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: site + '/wp-content/themes/lordwhitney/includes/json/logo.json'
});


var loaderAnimation = bodymovin.loadAnimation({
    container: document.getElementById('project-overlay__loader'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: site + '/wp-content/themes/lordwhitney/includes/json/star.json'
});